module.exports = __webpack_public_path__ + "media/images/official/guide_image4-baba734acdc2ef3e7e60cd91044c0e6f.svg";